module.exports = __webpack_public_path__ + "img/Wp_2002.df7b3f45.png";